import { render, staticRenderFns } from "./NsSepaForm.vue?vue&type=template&id=a9c5db30&scoped=true&"
import script from "./NsSepaForm.vue?vue&type=script&lang=js&"
export * from "./NsSepaForm.vue?vue&type=script&lang=js&"
import style0 from "./NsSepaForm.vue?vue&type=style&index=0&id=a9c5db30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c5db30",
  null
  
)

export default component.exports